import {mapGetters, mapActions} from "vuex";

export const CommonListMixin = {
    data() {
        return {
            formData: {},
            form:false,
            valid:false,
            errors: [],
            searchQuery: "",
            pagination: {
                itemsPerPage: 25
            },
            footerProps: {
                'items-per-page-options': [10, 25, 50, {text: 'All', 'value': -1}]
            }
        }
    },
    computed: {
        ...mapGetters("CommonList", ["loading", "totalNumber", "serverPagination"]),
        modelData: {
            get() {
                return {};
            },
            set(value) {
                this.$store.commit("CommonList/setModelData", value);
            }
        },
        query: {
            get() {
                return this.$store.state.CommonList.query;
            },
            set(value) {
                this.$store.commit("CommonList/setQuery", value);
            }
        }
    },
    methods: {
        ...mapActions("CommonList", ["create", "resetState", "getAll", "delete"]),
        async destroy(item, message) {
            await this.$dialog.confirm({
                text: "Do you really want to delete?",
                title: "Warning",
                actions: {
                    false: "No",
                    true: {
                        color: "red",
                        text: "Yes",
                        handle: () => {
                            this.delete([item.id])
                                .then(() => {
                                    this.getAll();
                                    this.$store.commit('Notification/showSuccess', message)
                                })
                                .catch(error => {
                                    console.error(error);
                                });
                        }
                    }
                }
            });
        },
        save(messageName , resetFormData = {}) {
            return new Promise((resolve,reject) => {
                this.create()
                    .then(() => {
                        this.form = false;
                        this.getAll();
                        this.errors = null;
                        if (this.formData.id === undefined) {
                            this.$store.commit("Notification/showSuccess", messageName + ' created successfully');
                        } else {
                            this.$store.commit("Notification/showSuccess", messageName + ' updated successfully');
                        }
                        this.formData = resetFormData;

                        resolve(true)
                    })
                    .catch(error => {
                        if (error.response.status === 422) {
                            this.errors = error.response.data.errors;
                        }
                        reject(error)
                    });
            })


        }
    },
    watch: {

        pagination: {
            handler() {
                this.$store.commit("CommonList/setServerPagination", this.pagination);
                this.getAll();
            },
            deep: true
        },
        searchQuery: _.debounce(function () {
            this.query = this.searchQuery;
            this.$store.commit("CommonList/setModel", this.model);

            this.getAll();
        }, 1000)
    },
    destroyed() {
        this.resetState();
    },
}
